module.exports = __webpack_public_path__ + "static/img/error.d1a260d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/error.png
// module id = 1099
// module chunks = 2